import React from 'react'
import assets from 'xui/assets'
import CommonLogo, { ICommonLogoOptionalProps } from './CommonLogo'

// const LOGO = require('../img/about/icon_mkp_channel.png')
const LOGO = assets.images.about.iconMkpChannel

const MkpDefaultLogo = (props: ICommonLogoOptionalProps) => <CommonLogo source={LOGO} {...props} />

export default MkpDefaultLogo
